import { Button, CircularProgress, styled } from "@mui/material";
import React from "react";
import { colors } from "../../utils/colors/Index";

const CustomButton = ({
  title = "click",
  variant = "contained",
  size = "medium",
  type = "button",
  loading = false,
  loadingSize = 20,
  handleClick = () => null,
  ...props
}) => {
  return (
    <ButtonRoot
      variant={variant}
      size={size}
      type={type}
      onClick={handleClick}
      {...props}
    >
      {loading ? (
        <CircularProgress
          size={loadingSize}
          sx={{ color: colors.background.primary }}
        />
      ) : (
        title
      )}
    </ButtonRoot>
  );
};

export default CustomButton;
const ButtonRoot = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "none",
}));
